import { CONFIG_VARS } from "../../constants/configuration";

/** GCS base URL from ENVIRONMENT_CONFIGS (pip_GCS_url) — same bucket as pip-videos etc. */
export function getGcsBaseUrl(): string | undefined {
  const url = CONFIG_VARS.pip_GCS_url;
  return url?.replace(/\/$/, "");
}

export function isGcsConfigured(): boolean {
  return Boolean(getGcsBaseUrl());
}

/**
 * When true, marketing images/videos load from bundled content/assets/ instead of GCS.
 * - VITE_CMS_LOCAL_ASSETS=true  → always bundled
 * - VITE_CMS_LOCAL_ASSETS=false → always GCS (when configured)
 * - unset in dev                → bundled (so a broken bucket URL still shows local files)
 * - unset in prod               → GCS first
 */
export function shouldUseBundledCmsAssets(): boolean {
  const flag = import.meta.env.VITE_CMS_LOCAL_ASSETS;
  if (flag === "true") return true;
  if (flag === "false") return false;
  return import.meta.env.DEV;
}

/** @deprecated use shouldUseBundledCmsAssets */
export function isCmsLocalAssetsOnly(): boolean {
  return shouldUseBundledCmsAssets();
}

export function getGcsContentJsonUrl(): string | undefined {
  const base = getGcsBaseUrl();
  return base ? `${base}/genius-content.json` : undefined;
}

export function getGcsAssetUrl(assetPath: string): string | undefined {
  if (shouldUseBundledCmsAssets()) return undefined;
  const base = getGcsBaseUrl();
  if (!base) return undefined;
  const normalized = assetPath.startsWith("assets/") ? assetPath : `assets/${assetPath}`;
  return `${base}/${normalized}`;
}

export function getCurrentCmsEnvironment(): string {
  return CONFIG_VARS.environment ?? "unknown";
}
